import { render } from "./ReserveResult.vue?vue&type=template&id=81283730&scoped=true"
import script from "./ReserveResult.vue?vue&type=script&lang=js"
export * from "./ReserveResult.vue?vue&type=script&lang=js"

import "./ReserveResult.vue?vue&type=style&index=0&id=81283730&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81283730"]])

export default __exports__